/*
 * patient-diagnosis (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { patientDiagnoses } from "./patient-diagnosis.schema"

export const DIAGNOSIS_TYPES = ["primary", "secondary"] as const
export type DiagnosisType = (typeof DIAGNOSIS_TYPES)[number]

/* Select */
export type PatientDiagnosis = z.infer<typeof selectPatientDiagnosisSchema>
export const selectPatientDiagnosisSchema = createSelectSchema(patientDiagnoses)

/* Filters */
export type PatientDiagnosisFilters = z.infer<typeof patientDiagnosisFiltersSchema>
export const patientDiagnosisFiltersSchema = z.object({
	id: z.string().optional(),
	patientId: z.string().optional(),
	diagnosisId: z.string().optional(),
	type: z.enum(DIAGNOSIS_TYPES).optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createPatientDiagnosisSchema = createInsertSchema(patientDiagnoses, {
	patientId: z.string().uuid(),
	diagnosisId: z.string().uuid(),
	type: z.enum(DIAGNOSIS_TYPES),
	yearDiagnosed: z.number().int().min(1900).max(2100).optional(),
}).partial(globalCreateExclude)
export type CreatePatientDiagnosis = z.infer<typeof createPatientDiagnosisSchema>

/* Update */
export const updatePatientDiagnosisSchema = createInsertSchema(patientDiagnoses)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdatePatientDiagnosis = z.infer<typeof updatePatientDiagnosisSchema>
